import NotificationSettings from '@notifications/components/NotificationSettings/NotificationSettings';
import UserProfilePanel from '../../components/UserProfilePanel/UserProfilePanel';
import ProfileSettingsContainer from '../ProfileSettingsContainer/ProfileSettingsContainer';
import SecurityTab from '../../components/SecurityTab/SecurityTab';

import useTabsWithRoutes from '../../hooks/useTabsWithRoutes';

export const PROFILE_TABS = [
	{ name: 'Profile', component: ProfileSettingsContainer, availableForUser: () => true },
	{ name: 'Security', component: SecurityTab, key: 'security', availableForUser: user => !user.isLinkedToExternalAuthProvider },
	{ name: 'Notifications', component: NotificationSettings, key: 'notifications', availableForUser: () => true }
];

const UserProfilePanelContainer = () => {
	const [ tabs, selectedTabIndex, onTabChanged ] = useTabsWithRoutes(
		PROFILE_TABS, 'section', '/user/profile'
	);

	return (
		<UserProfilePanel
			tabs={tabs}
			selectedTabIndex={selectedTabIndex}
			onTabChange={onTabChanged}
		/>
	);
};

export default UserProfilePanelContainer;
